function SortDown() {
  return (
    <svg width={40} height={25} viewBox="0 0 40 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.364 0h33.272c2.991 0 4.487 3.746 2.376 5.93L22.376 23.138c-1.314 1.359-3.438 1.359-4.739 0L.987 5.929C-1.122 3.746.374 0 3.365 0z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default SortDown;
